<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('sidebar.setting.registrar.specializationMajor')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card" v-if="toggleForm">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.addNew')}}</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.setting.name')}}</label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <b-form-group :label="$t('form.setting.addInList')">
                                    <b-form-radio v-model="type" name="type" value="specialization">{{$t('form.program.specialization')}}
                                    </b-form-radio>
                                    <b-form-radio v-model="type"  name="type" value="major">{{$t('form.program.major')}}
                                    </b-form-radio>
                                </b-form-group>

                                <b-button variant="primary" @click="submit">{{$t('button.save')}}</b-button>
                            </div>
                        </div>

                        <div class="card" v-else>
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.edit')}} {{type | capitalize}}</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.setting.name')}}</label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <b-button variant="primary" @click="update">{{$t('button.update')}}</b-button>
                                <b-button variant="outline-primary" @click="cancel">{{$t('button.cancel')}}</b-button>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.program.specialization')}}</div>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover" v-if="specializations.length">
                                    <thead>
                                        <tr class="header">
                                            <th>{{$t('form.setting.name')}}</th>
                                            <th class="text-right">{{$t('form.setting.action')}}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(position, index) in specializations" :key="index">
                                            <td>{{position.name}}</td>

                                            <td class="text-right">
                                                <button v-if="permissions.editSettingsProgramspecializationsmajors"
                                                    class="btn btn-info btn-sm" @click="edit(position, 'specialization')">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button v-if="permissions.deleteSettingsProgramspecializationsmajors"
                                                    class="btn btn-danger btn-sm" @click="remove(position, index)">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                            </div>

                            <pagination v-if="codesPagination.last_page > 1"
                                :pagination="codesPagination" :offset="5" @paginate="paginate()">
                            </pagination>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.program.major')}}</div>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover" v-if="majors.length">
                                    <thead>
                                        <tr class="header">
                                            <th>{{$t('form.setting.name')}}</th>
                                            <th class="text-right">{{$t('form.setting.action')}}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(position, index) in majors" :key="index">
                                            <td>{{position.name}}</td>

                                            <td class="text-right">
                                                <button v-if="permissions.editSettingsProgramcodestypes"
                                                    class="btn btn-info btn-sm" @click="edit(position, 'major')">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button v-if="permissions.deleteSettingsProgramcodestypes"
                                                    class="btn btn-danger btn-sm"
                                                    @click="remove(position, index, 'professor')">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                            </div>

                            <pagination v-if="typesPagination.last_page > 1" :pagination="typesPagination"
                                :offset="5" @paginate="paginate('professor')">
                            </pagination>
                        </div>
                    </div>
                </div>

                <div class="row">

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: ['permissions', 'dateFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,
                toggleForm: true,

                codesPagination: {
                    current_page: 1
                },
                typesPagination: {
                    current_page: 1
                },

                name: '',
                id: '',
                type: 'specialization',

                specializations: [],
                majors: []
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsProgramspecializationsmajors) {
                return this.$router.push('/');
            }

            this.getMajors();
            this.getSpecializations();
        },

        methods: {

            getSpecializations() {
                this.isLoading = true;
                axios
                    .get('/api/program-specializations-majors?type=specialization&page=' + this.typesPagination.current_page)
                    .then(response => {
                        this.specializations = response.data.data.data;
                        this.typesPagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error fetching program types');
                    });
            },

            getMajors() {
                this.isLoading = true;

                axios
                    .get('/api/program-specializations-majors?type=major&page=' + this.codesPagination.current_page)
                    .then(response => {
                        this.majors = response.data.data.data;
                        this.codesPagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error fetching program codes');
                    });
            },

            paginate(type = null) {

                if (type) {
                    this.getSpecializations();
                    return;
                }

                this.getMajors();
            },

            submit() {
                if (this.name == '') {
                    this.showAlert('Please add name to continue.', 'danger');
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .post(`/api/program-specializations-majors`, {
                        name: this.name,
                        type: this.type
                    })
                    .then(response => {

                        if (response.data.success) {
                            this.name = '';
                            this.showAlert(response.data.message);

                            if (this.type == 'specialization') {
                                this.specializations.unshift(response.data.data);
                            } else {
                                this.majors.unshift(response.data.data);
                            }
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    })
            },

            edit(item, type) {
                this.id = item.id;
                this.name = item.name;
                this.type = type;
                this.toggleForm = false;
            },

            update() {
                if (this.name == '') {
                    this.showAlert('Please add name to continue.', 'danger');
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .put(`/api/program-specializations-majors/${this.id}`, {
                        name: this.name,
                        type: this.type
                    })
                    .then(response => {
                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            if (this.type == 'major') {
                                this.majors.map(r => {
                                    if (r.id == this.id) {
                                        r.id = response.data.data.id;
                                        r.name = response.data.data.name;
                                    }
                                });
                            } else {
                                this.specializations.map(r => {
                                    if (r.id == this.id) {
                                        r.id = response.data.data.id;
                                        r.name = response.data.data.name;
                                    }
                                });
                            }

                            this.cancel();
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    })
            },

            cancel() {
                this.id = '';
                this.name = '';
                this.type = 'specialization';
                this.toggleForm = true;
            },

            remove(item, index, type = null) {
                if (!confirm(this.$t('form.validation.delete'))) {
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .delete(`/api/program-specializations-majors/${item.id}`)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            if (type) {
                                this.majors.splice(index, 1);
                                return;
                            }

                            this.specializations.splice(index, 1);
                        }
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    })
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            clear() {
                this.alert = false;
                this.message = '';
                this.alertClass = '';
            }
        }
    }

</script>
